export function i18nParamReplace(str: string, params: Record<string, string>): string | undefined {
  try {
    let result = str;
    for (const keyName in params) {
      if (Object.prototype.hasOwnProperty.call(params, keyName)) {
        const value = params[keyName] ?? '';

        result = result.replace(new RegExp(`\\{\\s*${keyName}\\s*\\}`, 'g'), value);
      }
    }

    return result;
  } catch (_error: unknown) {
    if (_error) {
      //
    }
    return undefined;
  }
}
